import Head from 'next/head';
import { Contact, Promo, Newsletter, Map, Header, Footer } from '@components';
import { useConfig } from '@hooks';

export function ContactPage() {
  const config = useConfig();

  return (
    <>
      <Head>
        <title>Kontakt | IKSEL Studio Reklamy - Reklama dla Twojej firmy</title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - Dane kontaktowe, dane firmy. Zadzwoń lub spotkajmy się osobiście. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Promo
        id="promo"
        title="Zainteresowany?"
        subtitle="Skorzystaj z naszych usług"
        description={`
          Pomogliśmy rozwinąć skrzydła dziesiątkom firm. Nie wahaj się -
          pomożemy także Twojej! Skontaktuj się z nami w celu otrzymania
          spersonalizowanej oferty.`}
        variant="full"
        links={[]}
        isMain={true}
      />

      <Contact
        id="formularz"
        title="Skontaktuj się z nami"
        subtitle="Odpowiemy na każde Twoje pytanie i dołożymy wszelkich starań, by wypromować Ciebie lub Twoją firmę."
        phones={['666 666 320', '666 666 324']}
        emails={['kamil@iksel.com.pl', 'emilia@iksel.com.pl']}
        addresses={['05-822 Milanówek', 'Królewska 41']}
      />

      <Newsletter
        id="newsletter"
        title="Bądź na bieżąco z najnowszymi promocjami"
        subtitle="Zapisz się do naszego newslettera i otrzymuj powiadomienia o nowych produktach."
      />

      <Map
        id="map"
        title="Odwiedź nas na miejscu"
        subtitle="Czekamy na Ciebie w naszym biurze."
        sections={[
          {
            name: 'Dane firmy',
            elements: [
              'IKSEL Studio Reklamy',
              '05-822 Milanówek',
              'Grudowska 6',
              'NIP: 529-164-74-00',
            ],
          },
          {
            name: 'Siedziba firmy',
            elements: ['05-822 Milanówek', 'Królewska 41'],
          },
        ]}
        map={{
          lat: 52.12435,
          lng: 20.68661,
          zoom: 14,
          key: config.google_map_key,
        }}
      />

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </>
  );
}

export default ContactPage;
